
import { Component, OnInit, ChangeDetectionStrategy, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-products',
  templateUrl: './no-products.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, TranslateModule]
})
export class NoProductsComponent implements OnInit {

  readonly onAction = output<{ action: string }>();
  constructor() { }

  ngOnInit(): void {
  }

  addProductModal() {
    this.onAction.emit({ action: "createProduct" });
  }
}